import "core-js/modules/es.array.concat";
import _objectSpread from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "/home/cooper/dev/qikan/dingkan_admin/node_modules/core-js/modules/es.array.iterator.js";
import "/home/cooper/dev/qikan/dingkan_admin/node_modules/core-js/modules/es.promise.js";
import "/home/cooper/dev/qikan/dingkan_admin/node_modules/core-js/modules/es.object.assign.js";
import "/home/cooper/dev/qikan/dingkan_admin/node_modules/core-js/modules/es.promise.finally.js";
import Vue from 'vue';
import * as R from 'ramda';
import * as moment from 'moment';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { ApolloClient } from 'apollo-client';
import { HttpLink } from 'apollo-link-http';
import { setContext } from 'apollo-link-context';
import VueApollo from 'vue-apollo';
import mavonEditor from 'mavon-editor';
import 'mavon-editor/dist/css/index.css';
import BaiduMap from 'vue-baidu-map';
import App from '@/App.vue';
import router from '@/router';
import store from '@/store';
import vuetify from '@/plugins/vuetify';
import 'vuetify/dist/vuetify.min.css';
Vue.use(BaiduMap, {
  ak: process.env.VUE_APP_BMAP_AK
});
Vue.config.productionTip = false;
Vue.prototype.$R = R;
var authLink = setContext(function (_, _ref) {
  var headers = _ref.headers;
  var token = localStorage.getItem(process.env.VUE_APP_LOCAL_STORAGE_KEY);
  return {
    headers: _objectSpread({}, headers, {
      authorization: token ? "Bearer ".concat(token) : ''
    })
  };
});
var link = new HttpLink({
  uri: process.env.VUE_APP_API_URL
});
var apolloClient = new ApolloClient({
  link: authLink.concat(link),
  cache: new InMemoryCache(),
  defaultOptions: {
    watchQuery: {
      fetchPolicy: 'no-cache',
      errorPolicy: 'ignore'
    },
    query: {
      fetchPolicy: 'no-cache',
      errorPolicy: 'all'
    }
  },
  connectToDevTools: true
});
var apolloProvider = new VueApollo({
  defaultClient: apolloClient
});
Object.defineProperties(Vue.prototype, {
  $R: {
    get: function get() {
      return R;
    }
  },
  $moment: {
    get: function get() {
      return moment;
    }
  }
});
Vue.use(VueApollo);
Vue.use(mavonEditor);
new Vue({
  store: store,
  vuetify: vuetify,
  apolloProvider: apolloProvider,
  router: router,
  render: function render(h) {
    return h(App);
  }
}).$mount('#app');